var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShadowRobot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 127,
    viewBox: "0 0 86 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.1781 32.5222L20.4123 24.6319C18.3406 24.2966 16.3894 25.7044 16.0542 27.7761L9.98467 65.2883C9.64946 67.36 11.0572 69.3112 13.1289 69.6464L61.8947 77.5368C63.9665 77.872 65.9177 76.4643 66.2529 74.3925L72.3224 36.8804C72.6576 34.8086 71.2499 32.8574 69.1781 32.5222Z",
    fill: "#4D8DF4",
    stroke: "#606060",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6311 45.2083C30.7028 45.5435 32.654 44.1357 32.9892 42.064C33.3244 39.9923 31.9167 38.041 29.845 37.7058C27.7732 37.3706 25.822 38.7784 25.4868 40.8501C25.1516 42.9218 26.5593 44.873 28.6311 45.2083Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8899 49.457C56.9616 49.7922 58.9128 48.3845 59.248 46.3128C59.5832 44.241 58.1755 42.2898 56.1038 41.9546C54.032 41.6194 52.0808 43.0271 51.7456 45.0989C51.4104 47.1706 52.8181 49.1218 54.8899 49.457Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0442 53.6216C30.9724 53.2864 29.0212 54.6941 28.686 56.7659C28.3508 58.8377 29.7585 60.7888 31.8303 61.124L33.0442 53.6216ZM46.8351 63.5518C48.9069 63.8871 50.8581 62.4794 51.1933 60.4076C51.5285 58.3358 50.1208 56.3846 48.049 56.0494L46.8351 63.5518ZM31.8303 61.124L46.8351 63.5518L48.049 56.0494L33.0442 53.6216L31.8303 61.124Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2227 13.5718L44.7949 28.5766",
    stroke: "#606060",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.85547 37.5122L2.42766 52.5171",
    stroke: "#606060",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8799 49.6511L77.4521 64.656",
    stroke: "#606060",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2238 13.572C49.2956 13.9072 51.2468 12.4995 51.582 10.4278C51.9172 8.35602 50.5095 6.40481 48.4377 6.0696C46.366 5.73439 44.4148 7.14212 44.0796 9.21386C43.7444 11.2856 45.1521 13.2368 47.2238 13.572Z",
    stroke: "#606060",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3801_128396)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.5,
    cy: 108,
    rx: 28.5,
    ry: 5,
    fill: "#A6C6F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3801_128396",
    x: 0,
    y: 97,
    width: 77,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.827451 0 0 0 0 0.886275 0 0 0 0 0.980392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3801_128396"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3801_128396",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadowRobot);
export default __webpack_public_path__ + "static/media/shadow_robot.a0dd5b66f6b976769daf88ef7fff4492.svg";
export { ForwardRef as ReactComponent };